<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Länk</div>
            </div>
            <input class="form-control" required readonly :value="route('integrations.createQuoteUsingTemplate')">
        </div>

        <p class="small">
            Utan <code>Idempotency-Key</code> skyddas identiska anrop automatiskt i 24 timmar.
            Skicka olika nycklar när två identiska anrop avsiktligt ska skapa varsin offert. Samma nyckel med ändrad data avvisas.
        </p>

        <p>Använd följande dataformat i JSON:</p>
        <pre><code>
                {
                uuid: "{{ uuid }}", // Must always be this specific value
                quote_template_id: Integer,

                customer_name: String,
                customer_email: String|null, //
                customer_phone: String|null, // +46NNNNNNNNN
                }
            </code></pre>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
import { v4 as uuidv4 } from 'uuid';
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const uuid = ref(null);
const serializedValue = computed(() => {
  return {
    uuid: uuid.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    uuid.value = modelValue.value.uuid;
  }
  if (!uuid.value) {
    uuid.value = uuidv4();
  }
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    onUpdate();
  }
}, {
  immediate: true
});
</script>
